<template>
  <div
    class="viq-source-card"
    :class="{ 'viq-source-card--locked': source.locked }"
    @click="handleClick"
  >
    <div class="viq-source-card__number">{{ index }}</div>
    <div class="viq-source-card__content">
      <span v-if="source.type" class="viq-source-card__type">{{ source.type }}</span>
      <h4 class="viq-source-card__title">{{ source.title || 'Untitled Source' }}</h4>
      <div class="viq-source-card__meta">
        <span v-if="source.jurisdiction" class="viq-source-card__jurisdiction">
          {{ source.jurisdiction }}
        </span>
        <span v-if="source.date" class="viq-source-card__date">
          {{ formatDate(source.date) }}
        </span>
      </div>
    </div>
    <div v-if="source.locked" class="viq-source-card__lock">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <rect x="3" y="6" width="8" height="7" rx="1" stroke="currentColor" stroke-width="1.2" />
        <path d="M5 6V4a2 2 0 014 0v2" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViqSourceCard",
  props: {
    source: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "";
      const d = new Date(dateStr);
      return d.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    },
    handleClick() {
      if (!this.source.locked) {
        this.$store.dispatch("Viq/openSlideOut", this.source);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-source-card {
  flex-shrink: 0;
  width: 200px;
  padding: $viq-space-md;
  background: $viq-bg-primary;
  border: 1px solid $viq-border;
  border-radius: $viq-radius-md;
  cursor: pointer;
  transition: border-color $viq-transition-fast, box-shadow $viq-transition-fast;
  position: relative;

  &:hover {
    border-color: $viq-accent;
    box-shadow: $viq-shadow-sm;
  }

  &--locked {
    opacity: 0.7;
    cursor: default;

    &:hover {
      border-color: $viq-warning;
    }
  }

  &__number {
    position: absolute;
    top: $viq-space-sm;
    right: $viq-space-sm;
    width: 20px;
    height: 20px;
    background: $viq-citation-bg;
    color: $viq-accent;
    font-size: 10px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
  }

  &__content {
    min-width: 0;
  }

  &__type {
    display: inline-block;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: $viq-accent;
    margin-bottom: $viq-space-xs;
  }

  &__title {
    font-size: $viq-font-sm;
    font-weight: 600;
    color: $viq-text-primary;
    margin: 0 0 $viq-space-sm;
    line-height: 1.3;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &__meta {
    display: flex;
    gap: $viq-space-sm;
    font-size: 10px;
    color: $viq-text-secondary;
  }

  &__jurisdiction {
    font-weight: 600;
  }

  &__lock {
    position: absolute;
    bottom: $viq-space-sm;
    right: $viq-space-sm;
    color: $viq-warning;
  }
}
</style>
